import { call, takeLatest } from 'redux-saga/effects'

import {
  OrganizationT,
  SWITCH_ORGANIZATION,
  SwitchOrganizationActionT,
} from '@signavio/effektif-api'

import history from '../history'

export function* triggerOrganizationSwitchSideEffects(
  action: SwitchOrganizationActionT
) {
  const { oldOrganization, newOrganization, currentPath } = action.payload

  yield call(
    history.push,
    getOrganizationSwitchUrl(oldOrganization, newOrganization, currentPath)
  )
}

export default function* watchLogoutActions() {
  yield takeLatest(SWITCH_ORGANIZATION, triggerOrganizationSwitchSideEffects)
}

const getOrganizationSwitchUrl = (
  currentOrganization: OrganizationT,
  nextOrganization: OrganizationT,
  currentPath: string
) => {
  if (currentPath.indexOf(`/${currentOrganization.key}/`) !== 0) {
    return currentPath
  }

  const base = `/${nextOrganization.key}`

  if (currentPath.indexOf('/cases/tasks/') >= 0) {
    return `${base}/cases/tasks`
  }

  if (currentPath.indexOf('/cases/') >= 0) {
    return `${base}/cases/overview`
  }

  if (currentPath.indexOf('/processes/') >= 0) {
    return `${base}/processes`
  }

  if (currentPath.indexOf('/report/') >= 0) {
    return `${base}/analytics`
  }

  if (currentPath.indexOf('/services/connectors/') >= 0) {
    return `${base}/services/connectors`
  }

  // URL change will trigger org switch
  if (currentOrganization.licenseRequired) {
    return `${base}/tasks`
  }

  return `${base}/${currentPath.substring(currentOrganization.key.length + 2)}`
}
